import React from "react";
import {
    Paper,
    FormLabel,
    Grid,
    Typography,
    Button,
    Chip,
    Tooltip,
    IconButton,
    LinearProgress,
    CircularProgress
} from "@material-ui/core";
import {AutorenewTwoTone, CloudDownload, Edit, FileCopyTwoTone} from "@material-ui/icons";
import {CopyToClipboard} from "react-copy-to-clipboard";

export default function Intigration(props) {
    const {
        id, apiKey, loading, isLoading, privateKey, isKeyGenerate, endPoint, isUpdateEndpoint
    } = props.allProps.Merchant;
    const { pubKeyDown, priKeyDown, generatePriKey } = props;
    return (
        <Grid item>
            {loading ? <LinearProgress/> : null}
            <Paper className={props.classes.paper} style={{"height": "auto"}}>

                <FormLabel component="legend">Intigrations</FormLabel>

                <Typography variant="overline" gutterBottom>Merchant ID: </Typography>
                <Grid container direction="row" justify="space-between" alignItems="flex-start">
                    <Grid item>
                        <Chip label={id} className={props.classes.chip} clickable color="primary"/>
                    </Grid>
                    <Grid item>
                        {(loading || !id) ? null :
                            <CopyToClipboard text={id} onCopy={props.copyStateChange}>
                                <Tooltip title={props.allState.copied ? "Copied" : "Copy"} placement="top">
                                    <IconButton variant="fab" mini="true" aria-label="Copy"
                                        className={props.classes.button}
                                        onMouseLeave={props.mouseLeave}>
                                        <FileCopyTwoTone/>
                                    </IconButton>
                                </Tooltip>
                            </CopyToClipboard>
                        }
                    </Grid>
                </Grid>

                <Grid container direction="row" justify="flex-start" alignItems="flex-start">
                    <Grid item xs={12} sm={12}>
                        <Typography variant="overline" gutterBottom>API Key: </Typography>
                        <Grid container direction="row" justify="space-between" alignItems="flex-start">
                            <Grid item>
                                <Chip label={apiKey} className={props.classes.chip} clickable color="primary"/>
                            </Grid>
                            <Grid item>
                                {loading ? null :
                                    <div>
                                        {isLoading ?
                                            <CircularProgress className={props.classes.progress} size={21}/>
                                            :
                                            <div>
                                                {apiKey ?
                                                    <CopyToClipboard text={apiKey} onCopy={props.copyStateChange}>
                                                        <Tooltip title={props.allState.copied ? "Copied" : "Copy"}
                                                            placement="top">
                                                            <IconButton variant="fab" mini="true" aria-label="Copy"
                                                                className={props.classes.button}
                                                                onMouseLeave={props.mouseLeave}>
                                                                <FileCopyTwoTone/>
                                                            </IconButton>
                                                        </Tooltip>
                                                    </CopyToClipboard>
                                                    :
                                                    <Tooltip title="Generate API key" placement="top">
                                                        <IconButton variant="contained" color="primary" size="small"
                                                            onClick={props.generateApiKey}
                                                            className={props.classes.button}>
                                                            <AutorenewTwoTone/>
                                                        </IconButton>
                                                    </Tooltip>
                                                }
                                            </div>
                                        }
                                    </div>
                                }
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={12}>
                        <Typography variant="overline" gutterBottom>Confirmation Endpoint: </Typography>
                        <Grid container direction="row" justify="space-between" alignItems="flex-start">
                            <Grid item>
                                <Chip label={endPoint} className={props.classes.chip} clickable color="primary"/>
                            </Grid>
                            <Grid item>
                                {loading ? null :
                                    <div>
                                        {isUpdateEndpoint ?
                                            <CircularProgress className={props.classes.progress} size={21}/>
                                            :
                                            <div>
                                                <Tooltip title="Set Confirmation Endpoint" placement="top">
                                                    <IconButton variant="outlined" color="secondary" size="small"
                                                        className={props.classes.button}
                                                        onClick={props.handleClickOpen}>
                                                        <Edit/>
                                                    </IconButton>
                                                </Tooltip>
                                                <CopyToClipboard text={endPoint} onCopy={props.copyStateChange}>
                                                    <Tooltip title={props.allState.copied ? "Copied" : "Copy"}
                                                        placement="top">
                                                        <IconButton variant="fab" mini="true" aria-label="Copy"
                                                            className={props.classes.button}
                                                            onMouseLeave={props.mouseLeave}>
                                                            <FileCopyTwoTone/>
                                                        </IconButton>
                                                    </Tooltip>
                                                </CopyToClipboard>
                                            </div>
                                        }
                                    </div>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Typography variant="overline" gutterBottom>Public/Private Key: </Typography>
                <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={8}>
                    <Grid item>
                        <Button variant="contained" color="default" className={props.classes.button} onClick={pubKeyDown}>
                            Public
                            <CloudDownload className={props.classes.rightIcon}/>
                        </Button>
                    </Grid>
                    <Grid item>
                        {privateKey ?
                            <Button variant="contained" color="default" className={props.classes.button} onClick={priKeyDown}>
                                Private
                                <CloudDownload className={props.classes.rightIcon}/>
                            </Button>
                            :
                            <div>
                                {isKeyGenerate ?
                                    <CircularProgress className={props.classes.progress} size={20}/>
                                    :
                                    <Tooltip title="Generate Private key" placement="top">
                                        <IconButton variant="contained" color="primary" size="small" onClick={generatePriKey}
                                            className={props.classes.button}>
                                            <AutorenewTwoTone/>
                                        </IconButton>
                                    </Tooltip>
                                }
                            </div>
                        }
                    </Grid>
                </Grid>

            </Paper>
        </Grid>
    );
}
